import { Link } from "react-router";

import { Button } from "~/components/ui/button";

// Shared 404 page: rendered by the catch-all route for unknown URLs, and by
// <SessionLayout> when GET /sessions/:id returns 404 (a session on a ward the
// caller can't access is indistinguishable from one that doesn't exist).
export default function NotFoundRoute(): JSX.Element {
  return (
    <section className="mx-auto flex w-full max-w-md flex-col items-center gap-4 py-16 text-center">
      <p className="text-sm font-medium text-muted-foreground">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        We couldn&apos;t find that page. It may have moved, or you may not have access to it.
      </p>
      <Button asChild>
        <Link to="/">Back to start</Link>
      </Button>
    </section>
  );
}
